<template>
  <div
    v-if="$$FormData.slicer_type === 'line'"
    class="diyImage-slicer line"
    :style="{
      padding: `0 ${$$FormData.slicer_padding}px`,
    }"
  >
    <div :style="{ borderTop: `1px ${$$FormData.slicer_style} ${$$FormData.slicer_color}` }" class="assist-slicer__hr" />
  </div>
  <div v-else class="diyImage-slicer" :style="{}">
    <!-- height: $$FormData.blank_height + 'px', -->
    <div class="swiper-pc2">
      <div
        v-for="(n, index) in $$FormData.diy_num"
        :key="index"
        class="div-z1"
        :style="{
          width: $$FormData.diy_image_width + 'px',
          height: $$FormData.diy_image_height + 'px',
        }"
      >
        <img
          :src="formatSrc(n).src"
          :style="{
            width: $$FormData.diy_image_width + 'px',
            height: $$FormData.diy_image_height + 'px',
          }"
        />
        <!-- {{ formatSrc(n).src }} -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiyImageSlicerPreview',

  data() {
    return {
      show_swiper: true,
    };
  },
  computed: {
    // swiperOptions() {
    //   const formData = this.$$FormData
    //   return {
    //     loop: true,
    //     pagination: formData.show_pagination ? { el: '.swiper-pagination' } : false,
    //     autoplay: formData.autoplay ? {
    //       disableOnInteraction: false,
    //     } : false,
    //     direction: formData.direction,
    //     effect: formData.effect
    //   }
    // }
  },
  watch: {
    // swiperOptions: {
    //   deep: true,
    //   handler: 'updateSwiper'
    // },
    // '$$FormData.imageList': {
    //   deep: true,
    //   handler: 'updateSwiper'
    // }
  },
  methods: {
    // updateSwiper() {
    //   this.show_swiper = false
    //   this.$nextTick(() => {
    //     this.show_swiper = true
    //   })
    // }
    /**
     * 格式化
     * @param item
     * @returns {{price: string, integer: string, decimal: string}}
     */
    formatSrc(n) {
      let str = 'diyimgt' + n;
      let nstr = String(this.$$FormData[str]);
      return {
        src: nstr,
      };
    },
  },
  mounted() {
    console.log(2222);
    // var bodyArray=document.getElementsByTagName("body");
    // var body = bodyArray[0];
    // //修改body元素的背景颜色属性
    // body.style.background = this.$$FormData.pagination_background;

    // console.log(this.$store.getters.site)
    // this.$store.getters.site.logo = this.$$FormData.pagination_logo
    // let zyzlogo1 = document.getElementsByClassName("zyzlogo1")[0];
    // zyzlogo1.style.display = "none";
    // let zyzlogo2 = document.getElementsByClassName("zyzlogo2")[0];
    // zyzlogo2.style.display = "block";
  },
};
</script>

<style lang="scss" scoped>
.diyImage-slicer {
  overflow: hidden;
  &__hr {
    width: 100%;
    margin: 10px 0;
    border: 0;
  }
}
.swiper-pc2 {
  // width: 764px;
  // background: black;
  .div-z1 {
    float: left;
    // background: black;
    margin: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Decors/DiyImageSlicer/DiyImageSlicerPreview.vue